
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M14 17V21H22V17M18 19V14M18 14L16 16M18 14L20 16"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.97 12.7809C21.9899 12.5232 22 12.2628 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C12.2628 22 12.5232 21.9899 12.7809 21.97C11.6771 20.805 11 19.2316 11 17.5C11 16.9296 11.0735 16.3763 11.2115 15.8492L11.0303 16.0303L10.4635 16.5972L9.93557 15.9939L6.43557 11.9939L7.56443 11.0061L10.5365 14.4028L16.4697 8.46967L17.5303 9.53033L15.8492 11.2115C16.3763 11.0735 16.9296 11 17.5 11C19.2316 11 20.805 11.6771 21.97 12.7809Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowExportCompleteFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
